import { render, staticRenderFns } from "./CellRendererItem.vue?vue&type=template&id=2f4b1488&scoped=true&"
import script from "./CellRendererItem.vue?vue&type=script&lang=js&"
export * from "./CellRendererItem.vue?vue&type=script&lang=js&"
import style0 from "./CellRendererItem.vue?vue&type=style&index=0&id=2f4b1488&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4b1488",
  null
  
)

export default component.exports